import { Link as SolitoLink } from 'solito/link'

import Box, { BoxProps } from 'app/components/base/Box'
import Image from 'app/components/base/Image'
import Link from 'app/components/base/Link'
import Skeleton from 'app/components/base/Skeleton'
import Stack, { StackProps } from 'app/components/base/Stack'
import { IMAGE_PRIORITY_INDEX } from 'app/utils/constants/blog.constants'
import { isOfType } from 'app/utils/helpers/type.helpers'

import CreatedAt from './CreatedAt'

export interface ArticleCardProps {
  sx?: StackProps['sx']
  imageContainerSx?: BoxProps['sx']
  link: string
  image: string
  createdAt: string
  title: string
  loading?: boolean
  index?: number
  isMobile?: boolean
  imageAltText?: string
}

const ArticleCard: RFC<ArticleCardProps> = ({
  image,
  createdAt,
  title,
  link,
  loading,
  index,
  isMobile,
  imageAltText,
  imageContainerSx,
  sx
}) => {
  return (
    <Stack sx={{ flexDirection: 'column', ...sx }}>
      <Skeleton
        loading={loading}
        variant="rectangular"
        height={285}
        width="100%"
        sx={{ borderRadius: 1, mx: 'auto' }}
      >
        <SolitoLink
          href={link}
          {...(isMobile && { prefetch: false })}
          aria-label={`Read article ${title}`}
        >
          <Box
            sx={{
              borderRadius: 1,
              overflow: 'hidden',
              position: 'relative',
              mx: 'auto',
              mb: 2,
              width: { xs: '100%', md: 260, lg: 285 },
              height: 285,
              ...(!!imageContainerSx && imageContainerSx)
            }}
          >
            <Image
              src={image}
              alt={imageAltText || title}
              fill
              sizes="300px"
              quality={100}
              {...(isOfType.number(index) && {
                priority: IMAGE_PRIORITY_INDEX.includes(index)
              })}
            />
          </Box>
        </SolitoLink>
      </Skeleton>

      <Skeleton loading={loading} width="80%" height="24px" sx={{ mb: 1 }}>
        <Link
          href={link}
          {...(isMobile && { prefetch: false })}
          lineClamp={1}
          variant="h3"
          sx={{ mb: 1 }}
        >
          {title}
        </Link>
      </Skeleton>

      <Skeleton loading={loading} width="30%" height="22px">
        <CreatedAt date={createdAt} />
      </Skeleton>
    </Stack>
  )
}

export default ArticleCard
